import { Stack } from 'expo-router'

type ExpoStackProps = React.ComponentProps<typeof Stack>

export const CardPaymentsLayout = ({ ExpoStackProps }: { ExpoStackProps: ExpoStackProps }) => (
  <Stack {...ExpoStackProps} />
)
